<div class="hero-dark"></div>
<div class="container">
  <div class="flex flex-column md:flex-row align-items-center md:justify-content-between">
    <div class="my-2">
      <div class="flex align-items-center gap-2">
        <h1>Sei pronto a partire?</h1>
        @if (environment.debug) {
        <pre>{{ checkout_type }}</pre>
        }
        <img src="assets/media/icons/airplane.png" height="40" />
      </div>
      <h3 class="mt-0">
        Completa la tua <span class="green">prenotazione</span>!
      </h3>
    </div>
    <div class="screen breadcrumb-container flex align-items-center">
      <p-breadcrumb [model]="items" />
    </div>
  </div>
  @if (invitation) {
  @if (notRightUser) {
  <div class="bg-muted-t alert-in-page mb-3">
    <div class="flex align-items-center gap-3">
      <p-avatar [image]="
              invitation.from_user.profile_picture | imagePipe: 'user-w' : 'sm'
            " shape="circle" size="large"></p-avatar>
      <div class="flex flex-column gap-1">
        <strong>{{ invitation.from_user.name }} ti ha invitato a
          partecipare!</strong>
        <small>Effettua il <a href="/login" class="clickable">login</a> e
          ritorna su questa pagina per poter accettare l'invito.</small>
      </div>
    </div>
  </div>
  } @else {
  <div class="bg-muted-t alert-in-page mb-3">
    <div class="flex align-items-center gap-3">
      <p-avatar [image]="
              invitation.from_user.profile_picture | imagePipe: 'user-w' : 'sm'
            " shape="circle" size="large"></p-avatar>
      <div class="flex flex-column gap-1">
        <strong>{{ invitation.from_user.name }} ti ha invitato a
          partecipare!</strong>
        <small>Compila i campi qui sotto e segui le istruzioni per partecipare a
          questo viaggio!</small>
      </div>
    </div>
  </div>
  }
  }
</div>

@if (loading) {
<div class="backdrop-mini-loader">
  <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
</div>
} @else {
@if (travel) {
<div [ngClass]="{ disabled: notRightUser }">
  <div class="bg-t p-3">
    <div class="flex align-items-center justify-content-between md:justify-content-center">
      <div class="step-box flex align-items-center justify-content-between">
        <div class="dotted-line"></div>
        <span class="pr-2" [ngClass]="{ active: menuIndex === 0 }" (click)="goTo(0)">• Dati della prenotazione</span>
        <span class="pl-2" [ngClass]="{
                active: menuIndex === 1,
                txt_disabled:
                  frmRooms.invalid ||
                  maxMembersExceeded ||
                  (travel.pricing_mode === 2 && isPaymentDisabled),
              }" (click)="goTo(1)">•
          {{
          frmJoin.get("third_party_booking")?.value
          ? "Registrazione"
          : "Pagamento"
          }}</span>
      </div>
    </div>
  </div>

  <div class="container mb-6">
    <form [formGroup]="frmJoin">
      @switch (menuIndex) {
      @case (0) {
      <div class="mt-4">
        <div class="grid grid-container">
          <div class="col-12 md:col-12 lg:col-8 md:pr-5">
            <h1>{{ travel.name }}</h1>
            @if (travel.has_flights === true) {
            <div class="mt-5 form-section mb-4">
              <div class="grid" [ngClass]="[
                            purchased_with_optional_flight.value === true
                              ? 'disabled'
                              : '',
                          ]">
                <div class="col-12 md:col-6 lg:col-6">
                  <strong>Andata</strong>
                  @for (d of travel.departures; track $index) {
                  <div class="flex align-items-start gap-3 mt-3">
                    <img src="/assets/media/icons/going.png" height="30" />
                    <div class="flex flex-column gap-1">
                      <span><strong>{{
                          d.flight.flight_company?.name
                          }}</strong>
                        <br />
                        {{ d.flight.from_airport?.name }} ({{
                        d.flight.from_airport?.code
                        }}) » {{ d.flight.to_airport?.name }} ({{
                        d.flight.to_airport?.code
                        }})</span>
                      <small>{{
                        d.flight.departure_date
                        | date: "dd/MM/yyyy, HH:mm"
                        }}
                        »
                        {{
                        d.flight.arrival_date
                        | date: "dd/MM/yyyy, HH:mm"
                        }}</small>
                    </div>
                  </div>
                  }
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <strong>Ritorno</strong>
                  @for (a of travel.arrivals; track $index) {
                  <div class="flex align-items-start gap-3 mt-3">
                    <img src="/assets/media/icons/going-back.png" height="30" />
                    <div class="flex flex-column gap-1">
                      <span><strong>{{
                          a.flight.flight_company?.name
                          }}</strong>
                        <br />{{ a.flight.from_airport?.name }} ({{
                        a.flight.from_airport?.code
                        }}) » {{ a.flight.to_airport?.name }} ({{
                        a.flight.to_airport?.code
                        }})</span>
                      <small>{{
                        a.flight.departure_date
                        | date: "dd/MM/yyyy, HH:mm"
                        }}
                        »
                        {{
                        a.flight.arrival_date
                        | date: "dd/MM/yyyy, HH:mm"
                        }}</small>
                    </div>
                  </div>
                  }
                </div>
              </div>
              @if (travel.optional_flight_purchase) {
              <div class="highlighted-flight-alert flex flex-column gap-1 mt-4">
                <span>Questo viaggio è acquistabile senza voli!
                  <small class="grey-text">(-{{
                    travel.optional_flight_purchase_discount
                    | currency
                    : travel.currency
                    : "symbol"
                    : ".2-2"
                    }}
                    sul totale)</small></span>
                <div class="flex align-items-center gap-3 mt-4">
                  <p-inputSwitch [formControl]="purchased_with_optional_flight" inputId="flight" />
                  <label for="flight" class="text-sm mb-1">Desidero acquistare il viaggio senza
                    volo.</label>
                </div>
              </div>
              }
            </div>
            }
            @if (travel.pricing_mode != 2) {
            <div class="form-section mb-4" [ngClass]="travel.has_flights === false ? 'mt-5' : ''">
              @if (maxMembersExceeded) {
              <div class="muted-r-bg alert-in-page mb-6 w-full">
                <div class="flex align-items-center flex-wrap gap-3">
                  <img src="/assets/media/icons/alert-g.png" width="40" />
                  <div class="flex flex-column gap-1">
                    <strong class="text-base">Solo
                      {{
                      travel.max_members -
                      travel.availability?.booked!
                      | availabilityPluralPipe
                      }}</strong>
                    <small>Riduci il numero degli adulti per poter
                      partecipare.</small>
                  </div>
                </div>
              </div>
              }
              @if (isGuest) {
              <b>Seleziona il numero di ospiti:</b>
              } @else {
              <strong>Seleziona le camere:</strong>
              }
              @for (
              r of frmRoomsControls;
              track $index;
              let roomIndex = $index
              ) {
              <div class="grid" [formGroup]="r">
                <div class="col">
                  <div class="mt-3">
                    <label>Adulti</label>
                    <div class="mt-1 select-button-box">
                      <p-selectButton [options]="adult_customers" formControlName="n_adults"
                        (onChange)="checkForAvailability()" />
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="mt-3">
                    <label>Bambini (2-8 anni)</label>
                    <div class="mt-1 select-button-box">
                      <p-selectButton [options]="kid_customers" formControlName="n_children" />
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="mt-3">
                    <label>Neonati (fino a 2 anni)</label>
                    <div class="mt-1 select-button-box">
                      <p-selectButton [options]="kid_customers" formControlName="n_infants" />
                    </div>
                  </div>
                </div>
                @if (frmRoomsControls.length > 1) {
                <div class="col-1">
                  <div class="h-full flex align-items-end justify-content-center">
                    <p-button [text]="true" icon="pi pi-trash" size="small"
                      (click)="remove($index, frmRooms)"></p-button>
                  </div>
                </div>
                }
                <div class="col-12">
                  @if (!isGuest) {
                  <div class="mt-3 border-b">
                    @if (r.get("n_adults")?.value === 2) {
                    <div class="flex align-items-center gap-3">
                      <div class="flex align-items-center gap-1 mt-4">
                        <p-radioButton formControlName="dbl_type" [inputId]="'double_bed' + $index" [value]="1" />
                        <label [for]="'double_bed' + $index" class="text-sm mb-1">Matrimoniale</label>
                      </div>
                      <div class="flex align-items-center gap-2 mt-4">
                        <p-radioButton formControlName="dbl_type" [inputId]="'single_bed' + $index" [value]="2" />
                        <label [for]="'single_bed' + $index" class="text-sm mb-1">Doppia</label>
                      </div>
                    </div>
                    } @else {
                    <div class="mt-4">
                      <h4>
                        {{
                        r.get("room_type")?.value
                        | roomTypePipe
                        }}
                      </h4>
                    </div>
                    }
                  </div>
                  }
                  <div class="mt-4 accordion-box" [ngClass]="maxMembersExceeded ? 'disabled' : ''">
                    <p-accordion [activeIndex]="activeIndex">
                      @for (
                      m of getFrmMembersControls($index);
                      track $index;
                      let memberIndex = $index
                      ) {
                      <p-accordionTab>
                        <ng-template pTemplate="header">
                          <h4>
                            Dati partecipante
                            {{ memberIndex + 1 }}
                            @if ($index === 0 && !isGuest) {
                            (intestatario pratica)
                            }
                          </h4>
                        </ng-template>
                        <ng-template pTemplate="content">
                          <div class="grid" [formGroup]="m">
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <label>Nome</label>
                                <input type="text" pInputText class="w-full mt-1" formControlName="name" />
                                @if (
                                m.get("name")?.errors &&
                                m.get("name")?.dirty
                                ) {
                                <st-errors [errors]="
                                                    m.get('name')?.errors
                                                  "></st-errors>
                                }
                              </div>
                            </div>
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <label>Cognome</label>
                                <input type="text" pInputText class="w-full mt-1" formControlName="last_name" />
                                @if (
                                m.get("last_name")?.errors &&
                                m.get("last_name")?.dirty
                                ) {
                                <st-errors [errors]="
                                                    m.get('last_name')?.errors
                                                  "></st-errors>
                                }
                              </div>
                            </div>
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <label>Data di nascita</label>
                                <p-calendar ngClass="w-full frm" [readonlyInput]="true" appendTo="body"
                                  panelStyleClass="custom-calendar" [touchUI]="false" [maxDate]="today"
                                  formControlName="date_of_birth" dateFormat="dd/mm/yy"
                                  [firstDayOfWeek]="1"></p-calendar>
                                @if (
                                m.get("date_of_birth")
                                ?.errors &&
                                m.get("date_of_birth")?.dirty
                                ) {
                                <st-errors [errors]="
                                                    m.get('date_of_birth')
                                                      ?.errors
                                                  "></st-errors>
                                }
                              </div>
                            </div>
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <label>Genere</label>
                                <p-dropdown [options]="genders" optionValue="id" optionLabel="name" ngClass="w-full frm"
                                  placeholder="Scegli" formControlName="gender"></p-dropdown>
                                @if (
                                m.get("gender")?.errors &&
                                m.get("gender")?.dirty
                                ) {
                                <st-errors [errors]="
                                                    m.get('gender')?.errors
                                                  "></st-errors>
                                }
                              </div>
                            </div>
                            <!-- <div class="col-12 md:col-4">
                                                          <div class="mt-3">
                                                              <label>Codice fiscale</label>
                                                              <input type="text" pInputText class="w-full mt-1"
                                                                  formControlName="fiscal_code" />
                                                              @if(m.get('fiscal_code')?.errors &&
                                                              m.get('fiscal_code')?.dirty){
                                                              <st-errors
                                                                  [errors]="m.get('fiscal_code')?.errors"></st-errors>
                                                              }
                                                          </div>
                                                      </div> -->
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <label>Telefono</label>
                                <input type="text" pInputText class="w-full mt-1" formControlName="phone_number" />
                                @if (
                                m.get("phone_number")?.errors &&
                                m.get("phone_number")?.dirty
                                ) {
                                <st-errors [errors]="
                                                    m.get('phone_number')
                                                      ?.errors
                                                  "></st-errors>
                                }
                              </div>
                            </div>
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <label>Email</label>
                                <input type="text" pInputText class="w-full mt-1" formControlName="email_address" />
                                @if (
                                m.get("email_address")
                                ?.errors &&
                                m.get("email_address")?.dirty
                                ) {
                                <st-errors [errors]="
                                                    m.get('email_address')
                                                      ?.errors
                                                  "></st-errors>
                                }
                              </div>
                            </div>
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <label>Cittadinanza</label>
                                <input type="text" pInputText class="w-full mt-1" formControlName="nationality" />
                                @if (
                                m.get("nationality")?.errors &&
                                m.get("nationality")?.dirty
                                ) {
                                <st-errors [errors]="
                                                    m.get('nationality')?.errors
                                                  "></st-errors>
                                }
                              </div>
                            </div>
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <label>Tipo di documento</label>
                                <p-dropdown [options]="id_type" optionValue="id" optionLabel="name" ngClass="w-full frm"
                                  placeholder="Scegli" formControlName="document_type"></p-dropdown>
                                @if (
                                m.get("document_type")
                                ?.errors &&
                                m.get("document_type")?.dirty
                                ) {
                                <st-errors [errors]="
                                                    m.get('document_type')
                                                      ?.errors
                                                  "></st-errors>
                                }
                              </div>
                            </div>
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <label>Scadenza documento</label>
                                <p-calendar ngClass="w-full frm" [firstDayOfWeek]="1"
                                  formControlName="document_exp_date" [readonlyInput]="true" appendTo="body"
                                  [minDate]="today" panelStyleClass="custom-calendar" [touchUI]="false"
                                  dateFormat="dd/mm/yy"></p-calendar>
                                @if (
                                m.get("document_exp_date")
                                ?.errors &&
                                m.get("document_exp_date")
                                ?.dirty
                                ) {
                                <st-errors [errors]="
                                                    m.get('document_exp_date')
                                                      ?.errors
                                                  "></st-errors>
                                }
                              </div>
                            </div>
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <label>Data emissione documento</label>
                                <p-calendar ngClass="w-full frm" [firstDayOfWeek]="1"
                                  formControlName="document_release_date" [readonlyInput]="true" appendTo="body"
                                  [maxDate]="today" panelStyleClass="custom-calendar" [touchUI]="false"
                                  dateFormat="dd/mm/yy"></p-calendar>
                                @if (
                                m.get("document_release_date")
                                ?.errors &&
                                m.get("document_release_date")
                                ?.dirty
                                ) {
                                <st-errors [errors]="
                                                    m.get(
                                                      'document_release_date'
                                                    )?.errors
                                                  "></st-errors>
                                }
                              </div>
                            </div>
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <label>Numero documento</label>
                                <input type="text" pInputText class="w-full mt-1" formControlName="document_number" />
                                @if (
                                m.get("document_number")
                                ?.errors &&
                                m.get("document_number")?.dirty
                                ) {
                                <st-errors [errors]="
                                                    m.get('document_number')
                                                      ?.errors
                                                  "></st-errors>
                                }
                              </div>
                            </div>
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <div class="flex align-items-center gap-2 mt-6">
                                  <p-inputSwitch formControlName="disabled" inputId="disabled" />
                                  <label for="disabled" class="text-sm mb-1">Disabile</label>
                                </div>
                              </div>
                            </div>
                            @if (isGuest) {
                            <!-- <div class="col-12 md:col-4">
                                                          <div class="mt-3">
                                                              <div class="flex align-items-center gap-2 mt-6"
                                                                  (click)="checkHolderGuest($index)">
                                                                  <p-inputSwitch [formControl]="account_holder_guest"
                                                                      inputId="holder" />
                                                                  <label for="holder" class="text-sm mb-1">Intestatario
                                                                      pratica</label>
                                                              </div>
                                                          </div>
                                                      </div> -->
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <div class="flex align-items-center gap-2 mt-6">
                                  <p-inputSwitch formControlName="tmp_account_holder_guest" inputId="holder{{
                                                      roomIndex
                                                    }}{{ memberIndex }}" (onChange)="
                                                      checkHolderGuest(
                                                        roomIndex,
                                                        memberIndex
                                                      )
                                                    " />
                                  <label for="holder{{ roomIndex }}{{
                                                      memberIndex
                                                    }}" class="text-sm mb-1">
                                    Intestatario pratica
                                  </label>
                                </div>
                              </div>
                            </div>
                            }
                          </div>
                        </ng-template>
                      </p-accordionTab>
                      }
                    </p-accordion>
                  </div>
                </div>
              </div>
              }
              @if (!isGuest) {
              <div class="out-green flex align-items-center mt-4">
                <p-button [outlined]="true" label="Aggiungi una camera" size="small" (click)="addRoom()"
                  styleClass="px-6" [disabled]="maxMembersExceeded"></p-button>
              </div>
              }
            </div>
            } @else {
            <b>Seleziona i pacchetti che desideri acquistare:</b>
            <!--PACCHETTI-->
            @for (
            p of travel.price_packages;
            track $index;
            let pkgIndex = $index
            ) {
            <div class="mt-5">
              <p-accordion [multiple]="false">
                <p-accordionTab (selected)="(expandedTabIndex === pkgIndex)"
                  (selectedChange)="onTabToggle(pkgIndex, $event)">
                  <!-- HEADER -->
                  <ng-template pTemplate="header">
                    <div class="flex flex-column gap-2 w-full">
                      <div class="w-full flex justify-content-between align-items-center gap-3">
                        <h3 class="m-0">{{ p.name }}</h3>
                        <h2 class="green m-0">
                          {{
                          p.price_per_person
                          | currency
                          : travel.currency
                          : "symbol"
                          : ".2-2"
                          }}
                        </h2>
                      </div>
                      <div class="grey-text p-0 font-normal" [ngClass]="{
                                      'description-truncated':
                                        expandedTabIndex !== pkgIndex,
                                    }" [innerHTML]="p.description"></div>
                    </div>
                  </ng-template>
                  <!-- CONTENT -->
                  <ng-template pTemplate="content">
                    <div class="flex flex-column gap-2">
                      <div class="flex align-items-center gap-1">
                        <img src="/assets/media/icons/check-g.png" height="18" />
                        <small>Ideato per
                          <b>{{ p.n_partecipants }}</b>
                          adult{{
                          p.n_partecipants > 1 ? "i" : "o"
                          }}.</small>
                      </div>
                      @if (
                      p.max_n_children > 0 && p.max_n_infants > 0
                      ) {
                      <div class="flex align-items-center gap-1">
                        <img src="/assets/media/icons/check-g.png" height="18" />
                        <small>Numero massimo di bambini (2-8 anni)
                          ammessi: <b>{{ p.max_n_children }}</b>.</small>
                      </div>
                      <div class="flex align-items-center gap-1">
                        <img src="/assets/media/icons/check-g.png" height="18" />
                        <small>Numero massimo di neonati (0-2 anni)
                          ammessi: <b>{{ p.max_n_infants }}</b>.</small>
                      </div>
                      }
                      @if (p.limited) {
                      <small class="orange">Questo pacchetto ha un numero limitato di
                        prenotazioni disponibili!</small>
                      }
                    </div>

                    @if (getPackageControls(p.id).length > 0) {
                    @for (
                    sp of getPackageControls(p.id).controls;
                    track $index;
                    let purchaseIndex = $index
                    ) {
                    <form [formGroup]="sp">
                      <div class="grid mt-4">
                        <div class="col-12 flex justify-content-between align-items-center">
                          <div class="flex align-items-center gap-2">
                            <h4 class="green m-0">
                              Acquisto #{{ $index + 1 }}
                            </h4>
                          </div>
                          <div class="flex out-green">
                            <p-button (click)="
                                                removePurchase(
                                                  pkgIndex,
                                                  purchaseIndex
                                                )
                                              " label="Rimuovi" size="small" styleClass="px-6"
                              [outlined]="true"></p-button>
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="partecipants-box adults px-3 py-2">
                            <label>Adulti</label>
                            <h3 class="m-0">
                              {{ p.n_partecipants }}
                            </h3>
                          </div>
                        </div>
                        @if (
                        p.max_n_children > 0 &&
                        p.max_n_infants > 0
                        ) {
                        <div class="col-4">
                          <!-- <div class="partecipants-box children px-3 py-2"> -->
                          <label>Bambini (2-8 anni)</label>
                          <input type="number" pInputText class="w-full mt-1" [max]="
                                                checkMaxNumberOfKids(
                                                  p.id,
                                                  'children'
                                                )
                                              " [min]="0" formControlName="n_children" (input)="
                                                validatePackageInput(
                                                  $event,
                                                  p.id,
                                                  purchaseIndex,
                                                  'n_children'
                                                );
                                                updateMembersForPurchase(
                                                  p.id,
                                                  purchaseIndex
                                                )
                                              " />
                          @if (
                          sp.get("n_children")?.errors &&
                          sp.get("n_children")?.touched
                          ) {
                          <st-errors [errors]="
                                                  sp.get('n_children')?.errors
                                                "></st-errors>
                          }
                          <!-- </div> -->
                        </div>
                        <div class="col-4">
                          <label>Neonati (fino a 2 anni)</label>
                          <input type="number" pInputText class="w-full mt-1" [max]="
                                                checkMaxNumberOfKids(
                                                  p.id,
                                                  'infants'
                                                )
                                              " [min]="0" formControlName="n_infants" (input)="
                                                validatePackageInput(
                                                  $event,
                                                  p.id,
                                                  purchaseIndex,
                                                  'n_infants'
                                                );
                                                updateMembersForPurchase(
                                                  p.id,
                                                  purchaseIndex
                                                )
                                              " />
                          @if (
                          sp.get("n_infants")?.errors &&
                          sp.get("n_infants")?.touched
                          ) {
                          <st-errors [errors]="
                                                  sp.get('n_infants')?.errors
                                                "></st-errors>
                          }
                        </div>
                        }
                        <div class="col-12 mt-4 accordion-box" [ngClass]="
                                            maxMembersExceeded ? 'disabled' : ''
                                          ">
                          <p-accordion [activeIndex]="activeIndex">
                            @for (
                            m of getFrmMembersControlsForPckgsById(
                            p.id,
                            purchaseIndex
                            );
                            track m;
                            let mIndex = $index
                            ) {
                            <p-accordionTab>
                              <ng-template pTemplate="header">
                                <h4>
                                  Dati partecipante
                                  {{ mIndex + 1 }} -
                                  {{
                                  m.get("member_type")
                                  ?.value
                                  }}
                                </h4>
                              </ng-template>
                              <ng-template pTemplate="content">
                                <div class="grid" [formGroup]="m">
                                  <div class="col-12 md:col-4">
                                    <div class="mt-3">
                                      <label>Nome*</label>
                                      <input type="text" pInputText class="w-full mt-1" formControlName="name" />
                                      @if (
                                      m.get("name")
                                      ?.errors &&
                                      m.get("name")?.dirty
                                      ) {
                                      <st-errors [errors]="
                                                              m.get('name')
                                                                ?.errors
                                                            "></st-errors>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-12 md:col-4">
                                    <div class="mt-3">
                                      <label> Cognome*</label>
                                      <input type="text" pInputText class="w-full mt-1" formControlName="last_name" />
                                      @if (
                                      m.get("last_name")
                                      ?.errors &&
                                      m.get("last_name")
                                      ?.dirty
                                      ) {
                                      <st-errors [errors]="
                                                              m.get('last_name')
                                                                ?.errors
                                                            "></st-errors>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-12 md:col-4">
                                    <div class="mt-3">
                                      <label>
                                        Data di
                                        nascita*</label>
                                      <p-calendar ngClass="w-full frm" [readonlyInput]="true" appendTo="body"
                                        panelStyleClass="custom-calendar" [touchUI]="false" [maxDate]="today"
                                        formControlName="date_of_birth" dateFormat="dd/mm/yy"
                                        [firstDayOfWeek]="1"></p-calendar>
                                      @if (
                                      m.get("date_of_birth")
                                      ?.errors &&
                                      m.get("date_of_birth")
                                      ?.dirty
                                      ) {
                                      <st-errors [errors]="
                                                              m.get(
                                                                'date_of_birth'
                                                              )?.errors
                                                            "></st-errors>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-12 md:col-4">
                                    <div class="mt-3">
                                      <label>Genere*</label>
                                      <p-dropdown [options]="genders" optionValue="id" optionLabel="name"
                                        ngClass="w-full frm" placeholder="Scegli" formControlName="gender"></p-dropdown>
                                      @if (
                                      m.get("gender")
                                      ?.errors &&
                                      m.get("gender")?.dirty
                                      ) {
                                      <st-errors [errors]="
                                                              m.get('gender')
                                                                ?.errors
                                                            "></st-errors>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-12 md:col-4">
                                    <div class="mt-3">
                                      <label>
                                        Telefono*</label>
                                      <input type="text" pInputText class="w-full mt-1"
                                        formControlName="phone_number" />
                                      @if (
                                      m.get("phone_number")
                                      ?.errors &&
                                      m.get("phone_number")
                                      ?.dirty
                                      ) {
                                      <st-errors [errors]="
                                                              m.get(
                                                                'phone_number'
                                                              )?.errors
                                                            "></st-errors>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-12 md:col-4">
                                    <div class="mt-3">
                                      <label>Email*</label>
                                      <input type="text" pInputText class="w-full mt-1"
                                        formControlName="email_address" />
                                      @if (
                                      m.get("email_address")
                                      ?.errors &&
                                      m.get("email_address")
                                      ?.dirty
                                      ) {
                                      <st-errors [errors]="
                                                              m.get(
                                                                'email_address'
                                                              )?.errors
                                                            "></st-errors>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-12 md:col-4">
                                    <div class="mt-3">
                                      <label>Cittadinanza*</label>
                                      <input type="text" pInputText class="w-full mt-1" formControlName="nationality" />
                                      @if (
                                      m.get("nationality")
                                      ?.errors &&
                                      m.get("nationality")
                                      ?.dirty
                                      ) {
                                      <st-errors [errors]="
                                                              m.get(
                                                                'nationality'
                                                              )?.errors
                                                            "></st-errors>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-12 md:col-4">
                                    <div class="mt-3">
                                      <label>Tipo di
                                        documento*</label>
                                      <p-dropdown [options]="id_type" optionValue="id" optionLabel="name"
                                        ngClass="w-full frm" placeholder="Scegli"
                                        formControlName="document_type"></p-dropdown>
                                      @if (
                                      m.get("document_type")
                                      ?.errors &&
                                      m.get("document_type")
                                      ?.dirty
                                      ) {
                                      <st-errors [errors]="
                                                              m.get(
                                                                'document_type'
                                                              )?.errors
                                                            "></st-errors>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-12 md:col-4">
                                    <div class="mt-3">
                                      <label>Scadenza
                                        documento*</label>
                                      <p-calendar ngClass="w-full frm" [firstDayOfWeek]="1"
                                        formControlName="document_exp_date" [readonlyInput]="true" appendTo="body"
                                        [minDate]="today" panelStyleClass="custom-calendar" [touchUI]="false"
                                        dateFormat="dd/mm/yy"></p-calendar>
                                      @if (
                                      m.get(
                                      "document_exp_date"
                                      )?.errors &&
                                      m.get(
                                      "document_exp_date"
                                      )?.dirty
                                      ) {
                                      <st-errors [errors]="
                                                              m.get(
                                                                'document_exp_date'
                                                              )?.errors
                                                            "></st-errors>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-12 md:col-4">
                                    <div class="mt-3">
                                      <label>Data emissione
                                        documento*</label>
                                      <p-calendar ngClass="w-full frm" [firstDayOfWeek]="1"
                                        formControlName="document_release_date" [readonlyInput]="true" appendTo="body"
                                        [maxDate]="today" panelStyleClass="custom-calendar" [touchUI]="false"
                                        dateFormat="dd/mm/yy"></p-calendar>
                                      @if (
                                      m.get(
                                      "document_release_date"
                                      )?.errors &&
                                      m.get(
                                      "document_release_date"
                                      )?.dirty
                                      ) {
                                      <st-errors [errors]="
                                                              m.get(
                                                                'document_release_date'
                                                              )?.errors
                                                            "></st-errors>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-12 md:col-4">
                                    <div class="mt-3">
                                      <label>Numero
                                        documento*</label>
                                      <input type="text" pInputText class="w-full mt-1"
                                        formControlName="document_number" />
                                      @if (
                                      m.get(
                                      "document_number"
                                      )?.errors &&
                                      m.get(
                                      "document_number"
                                      )?.dirty
                                      ) {
                                      <st-errors [errors]="
                                                              m.get(
                                                                'document_number'
                                                              )?.errors
                                                            "></st-errors>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-12 md:col-4">
                                    <div class="mt-3">
                                      <div class="flex align-items-center gap-2 mt-6">
                                        <p-inputSwitch formControlName="disabled" inputId="disabled" />
                                        <label for="disabled" class="text-sm mb-1">Disabile</label>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="flex align-items-center gap-2 mt-6">
                                    <p-inputSwitch inputId="holder" formControlName="is_account_holder" (click)="
                                                          setAccountHolderPckgs(
                                                            pkgIndex,
                                                            purchaseIndex,
                                                            mIndex
                                                          )
                                                        " />
                                    <label for="holder" class="text-sm mb-1">
                                      Intestatario pratica
                                    </label>
                                  </div>
                                </div>
                              </ng-template>
                            </p-accordionTab>
                            }
                          </p-accordion>
                        </div>
                        @if (checkIfIsDblRoom(p.name)) {
                        <div class="mt-3">
                          <p-message severity="warn"
                            text="Acquistando questo pacchetto si verrà abbinati in camera con un altro viaggiatore. Per indicare una preferenza sul compagno di stanza, utilizzare il box note qui sotto."></p-message>
                        </div>
                        <div class="col-12">
                          <label>Note</label>
                          <textarea rows="5" pInputTextarea class="w-full mt-1" formControlName="notes"
                            placeholder="Es. preferenze sul compagno di stanza"></textarea>
                        </div>
                        }
                        <div class="col-12">
                          <label>Allergie</label>
                          <textarea rows="5" pInputTextarea class="w-full mt-1" formControlName="allergies"
                            placeholder="Allergie o intolleranze da segnalare"></textarea>
                        </div>
                      </div>
                    </form>
                    }
                    }
                    @if (overbooking) {
                    <div class="muted-r-bg alert-in-page w-full mt-4">
                      <div class="flex align-items-center flex-wrap gap-3">
                        <img src="/assets/media/icons/alert-g.png" width="40" />
                        <div class="flex flex-column gap-1">
                          <strong class="text-base">Attenzione</strong>
                          <small>Hai raggiunto il numero massimo di
                            prenotazioni!</small>
                        </div>
                      </div>
                    </div>
                    }

                    <!-- [disabled]="!canAddPackage(p.id)" -->

                    <div class="flex out-green justify-content-center md:justify-content-end mt-4">
                      <p-button (click)="selectPackage(p.id)" label="Aggiungi" size="small" styleClass="px-6"
                        [outlined]="true"></p-button>
                    </div>
                  </ng-template>
                </p-accordionTab>
              </p-accordion>
            </div>
            }
            }
            @if (travel.addl_services.length > 0) {
            <!--SERVIZI AGGIUNTIVI-->
            <div class="form-section mb-4">
              <strong class="yellow">Servizi aggiuntivi:</strong>
              @for (s of travel.addl_services; track $index) {
              <div class="flex flex-column md:flex-row md:justify-content-between">
                <div class="flex flex-column md:flex-row align-items-center md:gap-2">
                  <h3>{{ s.title |titlecase }}</h3>
                  <h2 class="green">
                    {{
                    s.price
                    | currency
                    : travel.currency
                    : "symbol"
                    : ".2-2"
                    }}
                  </h2>
                  @if (getaddlServiceMembersTotal($index) > 0) {
                  <small class="md:mt-2 green">Acquistato x{{
                    getaddlServiceMembersTotal($index)
                    }}</small>
                  }
                </div>
                <div class="buttons-set out-green flex align-items-center gap-2">
                  @if (frmAddlService.length > 0) {
                  <p-button [outlined]="true" icon="pi pi-minus" [rounded]="true"
                    (click)="decreasePeople($index)"></p-button>
                  }
                  <p-button [outlined]="true" icon="pi pi-plus" [rounded]="true"
                    (click)="increasePeople($index)"></p-button>
                </div>
              </div>
              <small class="grey-text">{{ s.description | titlecase}}</small>

              }
            </div>
            }
            <!-- @if (travel.addl_insurances!.length > 0) { -->
            @if ((travel.addl_insurances?.length ?? 0) > 0) {
            <!--assicurazione-->
            <div class="form-section mb-4">
              <strong class="yellow">Assicurazioni:</strong>
              @for (s of travel.addl_insurances; track $index) {
              <div class="flex flex-column md:flex-row md:justify-content-between">
                <div class="flex flex-column md:flex-row align-items-center md:gap-2">

                  <h3>{{ s.title |titlecase}}</h3>
                  <h2 class="green">
                    {{
                    s.price
                    | currency
                    : travel.currency
                    : "symbol"
                    : ".2-2"
                    }}
                  </h2>
                  @if (getaddlInsurancesMembersTotal($index) > 0) {
                  <small class="md:mt-2 green">Acquistato x{{
                    getaddlInsurancesMembersTotal($index)
                    }}</small>
                  }
                </div>
                <div class="buttons-set out-green flex align-items-center gap-2">
                  @if (frmInsurances.length > 0) {
                  <p-button [outlined]="true" icon="pi pi-minus" [rounded]="true"
                    (click)="decreasePeopleInsurances($index)"></p-button>
                  }
                  <p-button [outlined]="true" icon="pi pi-plus" [rounded]="true"
                    (click)="increasePeopleInsurances($index)"></p-button>
                </div>
              </div>
              <small class="grey-text">{{ s.description }}</small>
              <hr class="mt-5">
              }
            </div>
            }
          </div>

          <div class="col-12 md:col-12 lg:col-4 mb-4">
            <div class="card-dep-container">
              <div class="travel-card card-dep">
                <div class="bg-travel" [ngStyle]="{
                            'background-image':
                              'url(' +
                              (travel
                                | travelImagePipe
                                | imagePipe: 'travel' : 'lg') +
                              ')',
                          }">
                  <div class="gradient"></div>
                  <div class="lonely-title">
                    <h3 class="m-0">
                      {{ travel.from_date | date: "dd MMMM yyyy" }} -
                      {{ travel.to_date | date: "dd MMMM yyyy" }}
                    </h3>
                  </div>
                </div>

                <div class="p-4">


                  <div class="section-card pt-0">
                    <!-- ACCONTO + SALDO -->
                    @if (checkout_type === "advance") {
                    @let acconto =
                    travel.checkout_advance! *
                    fullPaymentPkgs.tot_participants!;
                    @let accontoIns = acconto + addlInsurancesTotal;
                    @if(addlInsurancesTotal===0){
                    <small class="grey-text">Totale acconto
                      {{
                      acconto
                      | currency
                      : travel.currency
                      : "symbol"
                      : ".2-2"
                      }}
                      @if (
                      fullPaymentPkgs.fullTotal > 0 &&
                      travel.customer_pays_fees
                      ) {
                      (di cui Costi di servizio
                      {{
                      acconto * 0.03
                      | currency
                      : travel.currency
                      : "symbol"
                      : ".2-2"
                      }})
                      }
                    </small>}@else {

                    <small class="grey-text">Totale acconto
                      {{
                      accontoIns
                      | currency
                      : travel.currency
                      : "symbol"
                      : ".2-2"
                      }}
                      @if (
                      fullPaymentPkgs.fullTotal > 0 &&
                      travel.customer_pays_fees
                      ) {
                      (di cui Costi di servizio
                      {{
                      accontoIns * 0.03
                      | currency
                      : travel.currency
                      : "symbol"
                      : ".2-2"
                      }})
                      }
                    </small>
                    }
                    <h2 class="green m-0">
                      <i class="pi pi-shopping-cart mr-2" style="font-size: 1.2rem"></i>
                      {{
                      fullPaymentPkgs.fullTotal + addlServiceTotal + addlInsurancesTotal
                      | currency
                      : travel.currency
                      : "symbol"
                      : ".2-2"
                      }}
                    </h2>
                    <small class="grey-text">
                      @let saldo = fullPaymentPkgs.fullTotal
                      - acconto
                      - addlServiceTotal
                      - addlInsurancesTotal;

                      Saldo:
                      {{ saldo | currency : travel.currency : 'symbol' : '.2-2' }}
                      <!-- Saldo:
                      {{
                      fullPaymentPkgs.fullTotal -
                      acconto +
                      addlServiceTotal
                      | currency
                      : travel.currency
                      : "symbol"
                      : ".2-2"
                      }} -->
                      <!-- @if (
                      fullPaymentPkgs.fullTotal > 0 &&
                      travel.customer_pays_fees
                      ) {
                      (di cui Costi di servizio
                      {{
                      (fullPaymentPkgs.fullTotal -
                      acconto +
                      addlServiceTotal) *
                      0.03
                      | currency
                      : travel.currency
                      : "symbol"
                      : ".2-2"
                      }})
                      }
                    </small>
                    } -->
                      @if (
                      fullPaymentPkgs.fullTotal > 0 &&
                      travel.customer_pays_fees
                      ) {
                      (di cui Costi di servizio
                      {{
                      saldo *
                      0.03
                      | currency
                      : travel.currency
                      : "symbol"
                      : ".2-2"
                      }})
                      }
                    </small>
                    }
                    <!-- INTERO IMPORTO -->
                    @else {
                    <small class="grey-text">Totale</small>
                    <h2 class="green m-0">
                      <i class="pi pi-shopping-cart mr-2" style="font-size: 1.2rem"></i>
                      {{
                      fullPaymentPkgs.fullTotal + addlServiceTotal + addlInsurancesTotal
                      | currency
                      : travel.currency
                      : "symbol"
                      : ".2-2"
                      }}
                    </h2>
                    @if (
                    fullPaymentPkgs.fullTotal > 0 &&
                    travel.customer_pays_fees
                    ) {
                    <small class="grey-text">
                      (di cui Costi di servizio
                      {{
                      (fullPaymentPkgs.fullTotal +
                      addlServiceTotal + addlInsurancesTotal) *
                      0.03
                      | currency
                      : travel.currency
                      : "symbol"
                      : ".2-2"
                      }})
                    </small>
                    }
                    }
                  </div>

                  @if (frmJoin.get("with_flights")?.value === true) {
                  <div class="section-card flex align-items-center gap-3">
                    <img src="assets/media/icons/airplane-ticket-60.png" height="24" />
                    <span>Volo incluso</span>
                  </div>
                  } @else {
                  <div class="section-card flex align-items-center gap-3">
                    <img src="assets/media/icons/airplane-ticket-60.png" height="24" />
                    <span>Volo non incluso</span>
                  </div>
                  }
                  @if (travel.pricing_mode != 2) {
                  <div class="section-card">
                    <div class="flex flex-column gap-1">
                      <div class="flex align-items-center gap-3">
                        <img src="assets/media/icons/double-bed.png" height="24" />
                        <div class="flex flex-column">
                          <b>Totale camere</b>
                          <span>{{
                            fullPaymentLegacy.fullTotal -
                            fullPaymentLegacy.advanceTotal
                            | currency
                            : travel.currency
                            : "symbol"
                            : ".2-2"
                            }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  }
                  <div class="section-card">
                    <div class="flex flex-column gap-1">
                      <div class="flex align-items-center gap-3">
                        <img src="assets/media/icons/clipboard-60.png" height="24" />
                        <div class="flex flex-column">
                          <b>Documenti</b>
                          <div class="flex flex-column gap-1" [ngClass]="{ 'mt-2': luggage_attachment }">
                            <a (click)="insuranceTextDialog = true" class="link-o">Termini e condizioni</a>
                            @if (luggage_attachment) {
                            <a [href]="
                                          environmentMediaUrl +
                                          '/' +
                                          luggage_attachment.path
                                        " class="link-o">Assicurazione medico bagaglio</a>
                            }
                            @if (cancellation_attachment) {
                            <a [href]="
                                          environmentMediaUrl +
                                          '/' +
                                          cancellation_attachment.path
                                        " class="link-o">Assicurazione annullamento</a>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  @if (frmAddlService.length > 0) {
                  <div class="pad-card flex align-items-center gap-3">
                    <div class="flex flex-column gap-1">
                      <div class="flex align-items-center gap-3">
                        <img src="assets/media/icons/extra.png" height="24" />
                        <div class="flex flex-column gap-1">
                          <b>Servizi aggiuntivi</b>
                          @if (addlServiceTotal === 0) {
                          <small class="grey-text">Nessun servizio aggiuntivo
                            acquistato</small>
                          } @else {
                          <span>{{
                            addlServiceTotal
                            | currency
                            : travel.currency
                            : "symbol"
                            : ".2-2"
                            }}</span>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex align-items-center justify-content-center">
        <div [ngClass]="{
                    cursorNotAllowed:
                      overbooking ||
                      frmRooms.invalid ||
                      maxMembersExceeded ||
                      (travel.pricing_mode === 2 && isPaymentDisabled),
                  }">
          @if (
          travel.pricing_mode === 2 &&
          frmSelectedPackages.value.length === 0
          ) {
          <div class="flex flex-column align-items-center">
            <p-button label="Il tuo carrello è vuoto" size="small" styleClass="slide px-6" [disabled]="true"></p-button>
            <span class="yellow mt-2 text-xs">*Seleziona uno o più pacchetti per proseguire</span>
          </div>
          } @else {
          <div class="flex flex-column align-items-center">
            <p-button label="Vai al pagamento" size="small" styleClass="slide px-6 " (click)="goTo(1)" [disabled]="
                          overbooking ||
                          frmRooms.invalid ||
                          maxMembersExceeded ||
                          (travel.pricing_mode === 2 && isPaymentDisabled)
                        "></p-button>
            @if (
            overbooking ||
            frmRooms.invalid ||
            maxMembersExceeded ||
            (travel.pricing_mode === 2 && isPaymentDisabled)
            ) {
            <span class="yellow mt-2 text-xs">*Compila correttamente tutti i dati richiesti</span>
            }
          </div>
          }
        </div>
      </div>
      }
      @case (1) {
      <div class="mt-4">
        <div class="flex flex-column md:flex-row align-items-center md:justify-content-between">
          <div>
            <h2>Pagamento</h2>
            <small class="grey-text">Numero pratica #{{ travel.internal_code }}</small>
          </div>

          <div class="clickable block flex align-items-center gap-1 mb-3 mt-3 md:mt-0" (click)="goTo(0)">
            <i class="pi pi-chevron-left text-xs"></i>
            <small>Torna ai dati della prenotazione</small>
          </div>
        </div>
        <div class="mt-5 form-section mb-4">
          <strong>Dati dell'intestatario pratica</strong>
          <div class="grid mt-3">
            <div class="col-12 md:col-4">
              <label>Nome*</label>
              <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_name" />
              @if (
              frmJoin.get("accountholder_name")?.errors &&
              frmJoin.get("accountholder_name")?.touched
              ) {
              <st-errors [errors]="frmJoin.get('accountholder_name')?.errors"></st-errors>
              }
            </div>
            <div class="col-12 md:col-4">
              <label>Cognome*</label>
              <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_last_name" />
              @if (
              frmJoin.get("accountholder_last_name")?.errors &&
              frmJoin.get("accountholder_last_name")?.touched
              ) {
              <st-errors [errors]="
                            frmJoin.get('accountholder_last_name')?.errors
                          "></st-errors>
              }
            </div>
            <div class="col-12 md:col-4">
              <label>Codice fiscale*</label>
              <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_fiscal_code" />
              @if (
              frmJoin.get("accountholder_fiscal_code")?.errors &&
              frmJoin.get("accountholder_fiscal_code")?.dirty
              ) {
              <st-errors [errors]="
                            frmJoin.get('accountholder_fiscal_code')?.errors
                          "></st-errors>
              }
            </div>
            <div class="col-12 md:col-4">
              <label>Nazione di nascita*</label>
              <div class="mt-1">
                <p-autoComplete [forceSelection]="true" [suggestions]="suggestedCountries"
                  (completeMethod)="filterCountries($event)" field="name" dataKey="ISO" class="frm mt-1"
                  [emptyMessage]="'Nessun risultato trovato'" emptyFilterMessage="Nessun risultato trovato"
                  formControlName="accountholder_country_iso">
                </p-autoComplete>
                @if (
                frmJoin.get("accountholder_country_iso")?.errors &&
                frmJoin.get("accountholder_country_iso")?.touched
                ) {
                <st-errors [errors]="
                              frmJoin.get('accountholder_country_iso')?.errors
                            "></st-errors>
                }
              </div>
            </div>
            <div class="col-12 md:col-4">
              <label>Indirizzo*</label>
              <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_address" />
              @if (
              frmJoin.get("accountholder_address")?.errors &&
              frmJoin.get("accountholder_address")?.touched
              ) {
              <st-errors [errors]="
                            frmJoin.get('accountholder_address')?.errors
                          "></st-errors>
              }
            </div>
            <div class="col-12 md:col-4">
              <label>CAP*</label>
              <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_zip_code" />
              @if (
              frmJoin.get("accountholder_zip_code")?.errors &&
              frmJoin.get("accountholder_zip_code")?.touched
              ) {
              <st-errors [errors]="
                            frmJoin.get('accountholder_zip_code')?.errors
                          "></st-errors>
              }
            </div>
            <div class="col-12 md:col-4">
              <label>Città*</label>
              <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_city" />
              @if (
              frmJoin.get("accountholder_city")?.errors &&
              frmJoin.get("accountholder_city")?.touched
              ) {
              <st-errors [errors]="frmJoin.get('accountholder_cityv')?.errors"></st-errors>
              }
            </div>
            <div class="col-12 md:col-4">
              <label>Provincia*</label>
              <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_province" />
              @if (
              frmJoin.get("accountholder_province")?.errors &&
              frmJoin.get("accountholder_province")?.touched
              ) {
              <st-errors [errors]="
                            frmJoin.get('accountholder_provincev')?.errors
                          "></st-errors>
              }
            </div>
            <div class="col-12 md:col-4">
              <label>Telefono*</label>
              <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_mobile_phone" />
              @if (
              frmJoin.get("accountholder_mobile_phone")?.errors &&
              frmJoin.get("accountholder_mobile_phone")?.touched
              ) {
              <st-errors [errors]="
                            frmJoin.get('accountholder_mobile_phone')?.errors
                          "></st-errors>
              }
            </div>
            <div class="col-12 md:col-6">
              <label>Email*</label>
              <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_email" />
              @if (
              frmJoin.get("accountholder_email")?.errors &&
              frmJoin.get("accountholder_email")?.touched
              ) {
              <st-errors [errors]="frmJoin.get('accountholder_email')?.errors"></st-errors>
              }
            </div>
            <div class="col-12 md:col-6">
              <label [ngClass]="
                          frmJoin.get('confirm_email')?.enabled
                            ? ''
                            : 'disabled'
                        ">Conferma email*</label>
              <input type="text" pInputText class="w-full mt-1" formControlName="confirm_email" />
              @if (
              frmJoin.get("confirm_email")?.enabled &&
              frmJoin.get("accountholder_email")?.value !==
              frmJoin.get("confirm_email")?.value
              ) {
              <div>
                <small class="form-danger">Le email non coincidono</small>
              </div>
              }
            </div>
          </div>
        </div>

        @let tp = frmJoin.get("third_party_booking")!.value;

        <div class="mt-5 form-section mb-4">
          <div class="grid">
            <!--CASO ANTICIPO + SALDO-->
            @if (checkout_type === "advance") {
            <!-- NOT THIRD PARTY -->
            @if (!tp) {
            <div class="col-12 flex flex-column gap-2">
              <strong>Acconto</strong>
              <small class="grey-text">Paga in sicurezza con Stripe: utilizza la tua carta
                di credito o debito, oppure effettua un bonifico
                SEPA con la garanzia di una protezione avanzata dei
                tuoi dati. Prenota il tuo viaggio senza
                preoccupazioni!</small>
              <!-- <div class="flex align-items-center gap-1">
                <small class="grey-text">Totale:</small>
                <h3 class="yellow m-0">
                  {{
                  fullPaymentPkgs.advanceTotal
                  | currency
                  : travel.currency
                  : "symbol"
                  : ".2-2"
                  }}
                </h3>
              </div>
              @if (
              fullPaymentPkgs.fullTotal > 0 &&
              travel.customer_pays_fees
              ) {
              <small class="grey-text">
                (di cui Costi di servizio
                {{
                travel.checkout_advance! *
                fullPaymentPkgs.tot_participants! *
                0.03
                | currency
                : travel.currency
                : "symbol"
                : ".2-2"
                }})
              </small>
              } -->
              <div class="flex align-items-center gap-1">

                @let acconto =
                travel.checkout_advance! *
                fullPaymentPkgs.tot_participants!;
                @let accontoIns = acconto + addlInsurancesTotal;
                @if(addlInsurancesTotal===0){
                <small class="grey-text">Totale acconto
                  <h3 class="yellow m-0">
                    {{
                    acconto
                    | currency
                    : travel.currency
                    : "symbol"
                    : ".2-2"
                    }}</h3>
                  @if (
                  fullPaymentPkgs.fullTotal > 0 &&
                  travel.customer_pays_fees
                  ) {
                  (di cui Costi di servizio
                  {{
                  acconto * 0.03
                  | currency
                  : travel.currency
                  : "symbol"
                  : ".2-2"
                  }})
                  }
                </small>}@else {

                <small class="grey-text">Totale acconto
                  <h3 class="yellow m-0">
                    {{
                    accontoIns
                    | currency
                    : travel.currency
                    : "symbol"
                    : ".2-2"
                    }}</h3>
                  @if (
                  fullPaymentPkgs.fullTotal > 0 &&
                  travel.customer_pays_fees
                  ) {
                  (di cui Costi di servizio
                  {{
                  accontoIns * 0.03
                  | currency
                  : travel.currency
                  : "symbol"
                  : ".2-2"
                  }})
                  }
                </small>
                }





              </div>
              <div class="flex align-items-center gap-2 mt-2">
                <p-checkbox [binary]="true" [formControl]="tcAccept" inputId="acceptTc" />
                <div>
                  <label for="acceptTc">Accetto </label>
                  <span class="link-inline font-12" (click)="
                                  $event.stopImmediatePropagation(); openTc()
                                ">Termini e Condizioni</span>
                </div>
              </div>
            </div>
            }
            <!-- THIRD PARTY -->
            @else {
            <div class="col-12 flex flex-column gap-2">
              <strong>Acconto</strong>
              <small class="grey-text">Scegli se il viaggiatore verserà l'acconto tramite
                bonifico o contanti. Entrambe le transazioni saranno
                monitorabili nella pagina di gestione del viaggio.
                In caso di bonifico, invieremo una mail con le
                coordinate bancarie.</small>
              <!-- <div class="flex align-items-center gap-1">
                <small class="grey-text">Totale:</small>
                <h3 class="yellow m-0">
                  {{
                  fullPaymentPkgs.advanceTotal
                  | currency
                  : travel.currency
                  : "symbol"
                  : ".2-2"
                  }}
                </h3>
              </div>
              @if (
              fullPaymentPkgs.fullTotal > 0 &&
              travel.customer_pays_fees
              ) {
              <small class="grey-text">
                (di cui Costi di servizio
                {{
                travel.checkout_advance! *
                fullPaymentPkgs.tot_participants! *
                0.03
                | currency
                : travel.currency
                : "symbol"
                : ".2-2"
                }})
              </small>
              } -->
              @let acconto =
              travel.checkout_advance! *
              fullPaymentPkgs.tot_participants!;
              @let accontoIns = acconto + addlInsurancesTotal;
              @if(addlInsurancesTotal===0){
              <small class="grey-text">Totale acconto
                <h3 class="yellow m-0">
                  {{
                  acconto
                  | currency
                  : travel.currency
                  : "symbol"
                  : ".2-2"
                  }}</h3>
                @if (
                fullPaymentPkgs.fullTotal > 0 &&
                travel.customer_pays_fees
                ) {
                (di cui Costi di servizio
                {{
                acconto * 0.03
                | currency
                : travel.currency
                : "symbol"
                : ".2-2"
                }})
                }
              </small>}@else {

              <small class="grey-text">Totale acconto
                <h3 class="yellow m-0">
                  {{
                  accontoIns
                  | currency
                  : travel.currency
                  : "symbol"
                  : ".2-2"
                  }}</h3>
                @if (
                fullPaymentPkgs.fullTotal > 0 &&
                travel.customer_pays_fees
                ) {
                (di cui Costi di servizio
                {{
                accontoIns * 0.03
                | currency
                : travel.currency
                : "symbol"
                : ".2-2"
                }})
                }
              </small>
              }
            </div>
            <!-- PULSANTI SCELTA METODO DI PAGAMENTO -->
            <!-- cash adv -->
            <div class="col-12">
              <div class="method flex align-items-center justify-content-center gap-3 p-2"
                (click)="paymentMethod(enumPaymentMethod.CASH_ADV)" [ngClass]="
                              frmJoin.get('payment_method')?.value ===
                              enumPaymentMethod.CASH_ADV
                                ? 'chosen-method'
                                : ''
                            ">
                <img src="/assets/media/icons/money-flow.png" height="50" />
                <div>
                  <strong>Contanti</strong>
                </div>
              </div>
            </div>
            <!-- bank adv -->
            <div class="col-12">
              <div class="method flex align-items-center justify-content-center gap-3 p-2" (click)="
                              paymentMethod(enumPaymentMethod.BANK_TRANSFER_ADV)
                            " [ngClass]="
                              frmJoin.get('payment_method')?.value ===
                              enumPaymentMethod.BANK_TRANSFER_ADV
                                ? 'chosen-method'
                                : ''
                            ">
                <img src="/assets/media/icons/credit-cards-payment.png" height="50" />
                <div>
                  <strong>Bonifico bancario</strong>
                </div>
              </div>
            </div>
            @if (
            frmJoin.get("payment_method")?.value ===
            enumPaymentMethod.CASH_ADV
            ) {
            <div class="col-12 md:col-4">
              <div class="flex align-items-center gap-2 mt-6">
                <label for="tp_payed"> Segna come pagato </label>
                <p-inputSwitch inputId="tp_payed" [formControl]="payed" />
              </div>
            </div>
            }
            }
            }
            <!-- CASO SALDO COMPLETO -->
            @else {
            <!-- NOT THIRD PARTY -->
            @if (!tp) {
            <div class="col-12 flex flex-column gap-2">
              <strong>Saldo</strong>
              <small class="grey-text">Paga in sicurezza con <b>Stripe</b> utilizza la tua
                <b>carta di credito o debito</b>, oppure effettua un
                <b>bonifico SEPA</b> con la garanzia di una
                protezione avanzata dei tuoi dati. Prenota il tuo
                viaggio senza preoccupazioni!</small>
              <div class="flex align-items-center gap-1">
                <small class="grey-text">Totale:</small>
                <!-- <h3 class="yellow m-0">
                  {{
                  fullPaymentPkgs.fullTotal + addlServiceTotal
                  | currency
                  : travel.currency
                  : "symbol"
                  : ".2-2"
                  }}
                </h3>
              </div>
              @if (travel.customer_pays_fees) {
              <small class="grey-text">
                (di cui Costi di servizio
                {{
                (fullPaymentPkgs.fullTotal + addlServiceTotal) *
                0.03
                | currency
                : travel.currency
                : "symbol"
                : ".2-2"
                }})
              </small>
              } -->
                <h3 class="yellow m-0">
                  {{
                  fullPaymentPkgs.fullTotal + addlServiceTotal + addlInsurancesTotal
                  | currency
                  : travel.currency
                  : "symbol"
                  : ".2-2"
                  }}
                </h3>
              </div>
              @if (travel.customer_pays_fees) {
              <small class="grey-text">
                (di cui Costi di servizio
                {{
                (fullPaymentPkgs.fullTotal + addlServiceTotal+addlInsurancesTotal) *
                0.03
                | currency
                : travel.currency
                : "symbol"
                : ".2-2"
                }})
              </small>
              }
            </div>
            <div class="flex align-items-center gap-2 mt-2">
              <p-checkbox [binary]="true" [formControl]="tcAccept" inputId="acceptTc"></p-checkbox>

              <div>
                <label for="acceptTc">Accetto </label>
                <span class="link-inline font-12" (click)="
                                $event.stopImmediatePropagation(); openTc()
                              ">Termini e Condizioni</span>
              </div>
            </div>
            }
            <!-- THIRD PARTY -->
            @else {
            <div class="col-12 flex flex-column gap-2">
              <strong>Saldo</strong>
              <small class="grey-text">Scegli se il viaggiatore verserà l'importo tramite
                bonifico o contanti. Entrambe le transazioni saranno
                monitorabili nella pagina di gestione del viaggio.
                In caso di bonifico, invieremo una mail con le
                coordinate bancarie.</small>
              <div class="flex align-items-center gap-1">
                <small class="grey-text">Totale:</small>
                <!-- <h3 class="yellow m-0">
                  {{
                  fullPaymentPkgs.fullTotal + addlServiceTotal
                  | currency
                  : travel.currency
                  : "symbol"
                  : ".2-2"
                  }}
                </h3>
              </div>

              @if (travel.customer_pays_fees) {
              <small class="grey-text">
                (di cui Costi di servizio
                {{
                (fullPaymentPkgs.fullTotal + addlServiceTotal) *
                0.03
                | currency
                : travel.currency
                : "symbol"
                : ".2-2"
                }})
              </small>
              } -->
                <h3 class="yellow m-0">
                  {{
                  fullPaymentPkgs.fullTotal + addlServiceTotal+ addlInsurancesTotal
                  | currency
                  : travel.currency
                  : "symbol"
                  : ".2-2"
                  }}
                </h3>
              </div>

              @if (travel.customer_pays_fees) {
              <small class="grey-text">
                (di cui Costi di servizio
                {{
                (fullPaymentPkgs.fullTotal + addlServiceTotal + addlInsurancesTotal) *
                0.03
                | currency
                : travel.currency
                : "symbol"
                : ".2-2"
                }})
              </small>
              }
            </div>
            <!-- PULSANTI SCELTA METODO DI PAGAMENTO -->
            <!-- cash payoff -->
            <div class="col-12">
              <div class="method flex align-items-center justify-content-center gap-3 p-2" (click)="
                              paymentMethod(enumPaymentMethod.CASH_PAYOFF)
                            " [ngClass]="
                              frmJoin.get('payment_method')?.value ===
                              enumPaymentMethod.CASH_PAYOFF
                                ? 'chosen-method'
                                : ''
                            ">
                <img src="/assets/media/icons/money-flow.png" height="50" />
                <div>
                  <strong>Contanti</strong>
                </div>
              </div>
            </div>
            <!-- bank payoff -->
            <div class="col-12">
              <div class="method flex align-items-center justify-content-center gap-3 p-2" (click)="
                              paymentMethod(
                                enumPaymentMethod.BANK_TRANSFER_PAYOFF
                              )
                            " [ngClass]="
                              frmJoin.get('payment_method')?.value ===
                              enumPaymentMethod.BANK_TRANSFER_PAYOFF
                                ? 'chosen-method'
                                : ''
                            ">
                <img src="/assets/media/icons/credit-cards-payment.png" height="50" />
                <div>
                  <strong>Bonifico bancario</strong>
                </div>
              </div>
            </div>
            @if (
            frmJoin.get("payment_method")?.value ===
            enumPaymentMethod.CASH_PAYOFF
            ) {
            <div class="col-12 md:col-4">
              <div class="flex align-items-center gap-2 mt-6">
                <label for="tp_payed"> Segna come pagato </label>
                <p-inputSwitch inputId="tp_payed" [formControl]="payed" />
              </div>
            </div>
            }
            }
            }
          </div>
        </div>
      </div>

      <div class="flex align-items-center justify-content-center m-6">
        <div [ngClass]="{
                    cursorNotAllowed: frmJoin.invalid,
                  }">
          <p-button styleClass="w-full slide" [label]="tp ? 'Registra' : 'Paga'"
            [disabled]="frmJoin.invalid || !tcAccept.value" (click)="submit()" [loading]="loading"></p-button>
        </div>
      </div>
      }
      }
    </form>
  </div>
</div>
}
}
<p-dialog [closable]="true" header="Termini e Condizioni" [modal]="true" [(visible)]="visible"
  [style]="{ width: '50rem' }" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">
  <ng-template pTemplate="body">
    <div class="text">
      <section class="terms">
        <h3>1. Premessa</h3>
        <p>
          Il presente documento disciplina i termini e le condizioni relativi
          alla partecipazione e alle donazioni effettuate per i viaggi
          organizzati come progetti in fase di sviluppo. La natura progettuale
          implica che la realizzazione del viaggio non sia garantita.
        </p>

        <h3>2. Natura del Progetto</h3>
        <p>
          I viaggi proposti sono iniziative progettuali, soggette a valutazioni
          organizzative, logistiche ed economiche. La pubblicazione di un
          progetto non costituisce impegno vincolante alla sua effettiva
          realizzazione.
        </p>

        <h3>3. Donazioni</h3>
        <p>
          Le somme versate dagli utenti hanno natura di donazione e non di
          pagamento per un servizio già garantito. La donazione sostiene
          l’organizzazione e lo sviluppo del progetto, ma non dà diritto
          automatico alla partecipazione al viaggio. In caso di mancata
          realizzazione del progetto, la donazione non sarà rimborsata, salvo
          diversa comunicazione ufficiale da parte dell’organizzazione.
        </p>

        <h3>4. Conferma del Viaggio</h3>
        <p>
          Solo al raggiungimento delle condizioni necessarie (es. numero minimo
          di partecipanti, copertura dei costi, autorizzazioni) il viaggio sarà
          confermato. L’organizzazione si riserva il diritto di modificare,
          rinviare o annullare il progetto.
        </p>

        <h3>5. Responsabilità</h3>
        <p>
          L’organizzazione non è responsabile per eventuali spese sostenute
          autonomamente dagli utenti (es. voli, assicurazioni, prenotazioni
          esterne) prima della conferma ufficiale del viaggio. La partecipazione
          sarà possibile solo dopo comunicazione formale di conferma da parte
          dell’organizzazione.
        </p>

        <h3>6. Comunicazioni</h3>
        <p>
          Gli utenti saranno informati tramite i canali ufficiali (email,
          piattaforma, sito web) circa lo stato del progetto e l’eventuale
          conferma o annullamento.
        </p>

        <h3>7. Accettazione</h3>
        <p>
          Effettuando la donazione e aderendo al progetto, l’utente dichiara di
          aver letto e accettato integralmente i presenti Termini e Condizioni.
        </p>
      </section>
    </div>
  </ng-template>
</p-dialog>

<!-- <p-dialog
  header="Termini e condizioni"
  [modal]="true"
  [(visible)]="insuranceTextDialog"
  [style]="{ width: '50rem' }"
  [draggable]="false"
>
  <div [innerHTML]="travel?.terms_and_conds">

  </div>
</p-dialog> -->
<!-- <pre>{{ bookingDate | date: "dd/MM/yyyy" }}</pre> -->
<!-- <pre>{{ frmJoin.value | json }}</pre> -->